
import { computed, defineComponent } from "vue";

import {
  ColumnDefinition,
  useDataTable,
  DataTable,
  BaseButton,
  EditIcon,
  CountButton,
  DeleteIcon,
} from "@tager/admin-ui";
import { Page } from "@tager/admin-layout";
import { useResourceDelete } from "@tager/admin-services";

import { deleteCollection, getCollectionList } from "@/services/requests";
import { CollectionType } from "@/typings/model";
import {
  getFieldListUrl,
  getProductListUrl,
  getCollectionFormUrl,
} from "@/utils/paths";
import { getWebsiteOrigin } from "@/utils/common";

const COLUMN_DEFS: Array<ColumnDefinition<CollectionType>> = [
  {
    id: 1,
    name: "ID",
    field: "id",
    style: { width: "50px", textAlign: "center" },
    headStyle: { width: "50px", textAlign: "center" },
  },
  {
    id: 3,
    name: "Картинка",
    field: "image",
    type: "image",
    style: { width: "200px" },
    headStyle: { width: "200px" },
  },
  {
    id: 2,
    name: "Название",
    field: "name",
    type: "name",

    format: ({ row }) => ({
      adminLink: {
        text: row.name,
        url: getCollectionFormUrl({ collectionId: row.id }),
      },
      websiteLink: {
        text: getWebsiteOrigin() + row.url,
        url: getWebsiteOrigin() + row.url,
      },
    }),
  },
  {
    id: 4,
    name: "Производитель",
    field: "brand",
    type: "string",
    format: ({ row }) => row.brand.name,
    style: { width: "200px", whiteSpace: "nowrap" },
    headStyle: { width: "200px" },
  },
  {
    id: 5,
    name: "",
    field: "products",
    style: { width: "101px", whiteSpace: "nowrap" },
    headStyle: { width: "101px" },
  },
  {
    id: 6,
    name: "Действия",
    field: "actions",
    style: { width: "101px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "101px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "CollectionList",
  components: {
    Page,
    DataTable,
    BaseButton,
    EditIcon,
    CountButton,
    DeleteIcon,
  },
  setup() {
    const {
      isLoading: isCollectionListLoading,
      rowData: collectionList,
      errorMessage,
      searchQuery,
      handleChange,
      fetchEntityList: fetchCollectionList,
    } = useDataTable<CollectionType>({
      fetchEntityList: (params) =>
        getCollectionList({ query: params.searchQuery }),
      initialValue: [],
      resourceName: "Collection list",
    });

    const { handleResourceDelete: handleCollectionDelete, isDeleting } =
      useResourceDelete({
        deleteResource: deleteCollection,
        resourceName: "Collection",
        onSuccess: fetchCollectionList,
      });

    const isRowDataLoading = computed<boolean>(
      () => isCollectionListLoading.value
    );

    function isBusy(collectionId: number): boolean {
      return isDeleting(collectionId) || isRowDataLoading.value;
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: collectionList,
      isRowDataLoading,
      errorMessage,
      isBusy,
      handleCollectionDelete,
      getCollectionFormUrl,
      getFieldListUrl,
      getProductListUrl,
      searchQuery,
      handleChange,
    };
  },
});
